import React from 'react'
import './style.css'
import {Link} from 'react-router-dom' 

const breakPoint = 582;
const acessScrollPoint = 500; // ponto Y no qual a página desce após acessar, quanto maior valor, mais em baixo
const baseOpacity = 0.1;

const scrollToTop = () =>{
    window.scroll({
        top: 0, 
        left: 0, 
        behavior: 'smooth' 
      });
}
const scrollPageCustom = () =>{
    window.scroll({
        top: 0, 
        left: 0
      });
    window.scroll({
        top: acessScrollPoint, 
        left: 0, 
        behavior: 'smooth' 
      });
}

export default class Nav extends React.Component{
    state={
        ui :'normal',
        y : baseOpacity
    }

    componentDidMount(){
        window.addEventListener('scroll', ()=>{
            if(parseInt(window.pageYOffset) <= breakPoint) {
                let a = baseOpacity-(parseInt(window.pageYOffset)/(breakPoint*2));
                this.setState({ui:'normal', y : a})
            }
            if(parseInt(window.pageYOffset) > breakPoint) this.setState({ui:'fixed', y : 0})
        })
    }
    render(){
        return(
            <div className={`nav_wrapper`}
                style={{backgroundImage: `linear-gradient(to bottom, rgba(255,255,255,${this.state.y}) 0%,rgba(255,255,255,${this.state.y}) 100%), url('nav.png')`}}
            >
                <Link className='box' onClick={scrollToTop} to='/'>
                    <img src={'rendered.png'} className='bar_logo'/>
                </Link>
                <div className='inner_wrapper'>
                    <Link className='box' onClick={scrollToTop} to='/'>Início</Link>
                    {/* <Link className='box' onClick={scrollPageCustom} to='/empreendimento'>Empreendimento</Link> */}
                    <Link className='box' onClick={scrollPageCustom} to='/imagens'>Confira as imagens</Link>
                    <Link className='box' onClick={scrollPageCustom} to='/mapa'>Áreas disponíveis</Link>
                    <Link className='box' onClick={scrollPageCustom} to='/contato'>Entre em contato</Link>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/website/header/nav/component.js